



















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { PortinerieCreateBody, PortinerieReplaceBody } from "operatn-api-client";

import OperatnDateInput from "@/components/gears/inputs/OperatnDateInput.vue";

@Component({
  components: {
    OperatnDateInput,
  },
  model: {
    prop: "value",
    event: "save",
  },
})
export default class OperatnPortineriaForm extends Vue {
  /* PROPS */

  @Prop({ type: Object, default: null })
  value!: PortinerieCreateBody | PortinerieReplaceBody;

  @Prop({ type: Boolean, default: false })
  formValid!: boolean;

  @Prop({ type: Array, default: () => [] })
  portinerieValues!: string[];

  /* GETTERS AND SETTERS */

  get internalValue() {
    return this.value;
  }
  set internalValue(value) {
    this.$emit("save", value);
  }

  get internalFormValid() {
    return this.formValid;
  }
  set internalFormValid(value) {
    this.$emit("update:formValid", value);
  }

  /* METHODS */

  getEmptyValue(): PortinerieCreateBody | PortinerieReplaceBody {
    return {
      nome: "",
    };
  }

  /* WATCH */

  @Watch("value", { deep: true, immediate: true })
  watchValue() {
    if (this.value === null) {
      this.internalValue = this.getEmptyValue();
    }
  }
}
